<button class="btn btn-lg btn-primary w-100 text-white" (click)="redirectToExternalProvider()">
  <i class="fas fa-sign-in-alt"></i> {{getButtonLabel() | translate}}
</button>
